
import { sortItemsToFacet } from './Util';

class FactfinderSortSelect {

	constructor( wrapperEl ) {
		this.wrapperEl = wrapperEl;

		this.selectEl = this.wrapperEl.querySelector( 'select' );
		this.selectEl.addEventListener( 'change', () => this.onChange() );
	}

	manipulateResponse( responseData ) {
		const map = {
			'sort.relevanceDescription': 'Relevanz',
			'sort.pubDateAsc': 'Neu eingetroffen',
			'sort.brandDesc': 'Name absteigend',
			'sort.brandAsc': 'Name aufsteigend',
			'sort.titleDesc': 'Produkttitel absteigend',
			'sort.titleAsc': 'Produkttitel aufsteigend',
			'sort.priceDesc': 'Preis absteigend',
			'sort.priceAsc': 'Preis aufsteigend',
		};

		const orderedKeys = Object.keys( map ).toReversed();
		responseData.sortItems = responseData.sortItems.map( sortItem => {
			sortItem.label = map[ sortItem.description ] ?? null;
			return sortItem;
		} ).toSorted( ( itemA, itemB ) => {
			const indexA = orderedKeys.indexOf( itemA.description );
			const indexB = orderedKeys.indexOf( itemB.description );

			return indexB - indexA;
		} );

		responseData.facets.unshift( sortItemsToFacet( responseData.sortItems ) );

		return responseData;
	}

	async update( {sortItems} ) {

		this.sortItems = sortItems;

		const selectEl = this.wrapperEl.querySelector( 'select' );
		const optionEls = sortItems.map( sortItem => {
			const optionEl = document.createElement( 'option' );
			optionEl.value = sortItem.description;
			optionEl.selected = sortItem.selected;
			optionEl.innerHTML = sortItem.label || `${ sortItem.name } ${ sortItem.order }`;
			optionEl.dataset.searchParams = JSON.stringify( sortItem.searchParams )
			return optionEl;
		} );

		selectEl.replaceChildren( ...optionEls );
	}

	onChange = () => {
		const searchParams = JSON.parse( this.selectEl.options[ this.selectEl.selectedIndex ].dataset.searchParams );
		if ( searchParams ) {
			this.wrapperEl.dispatchEvent( new CustomEvent( 'change.ff', { bubbles: true, detail: { searchParams } } ) );
		}
	}
}

export default FactfinderSortSelect;
